<template lang="pug">
  div(
    :class="currentConfig.cardClass"
  ).analytic.report-download.report-card
    component(
      :is="modalWindowComponent"
      ref="modalForm"
      @submitModalForm="submitModal()"
      @closeModal="closeModal()"
      :hideDeleteButton="false"
      saveBtnLabel="Скачать"
      savingBtnLabel="Скачивание"
      :autoRoute="false"
      :autoHeight="true"
    )
      div(slot="header")
        template(
        v-if="currentConfig.windowType === SMALL_MODAL"
        )
          h1.title Скачивание отчета
          div.subtitle {{currentConfig.title}}
        template(v-else)
          e-breadcrumbs
          h1.title {{currentConfig.title}}
      slot
        e-form(:formValidator="formValidator")
          div
            div.body.body-table.body-table--border
              div.table-choose-panel
                div.toolbar-table
                  div.toolbar.toolbar--modal.toolbar--extended
                    div.line
                      template(v-if="reportId===REPORT_NAME.ACT_RECONCILIATION")
                        Legals(
                        :fields="fields"
                        :required="true"
                        ).is-full-width
                        Period(
                        :fields="fields"
                        :required="true"
                        ).is-full-width
                        div.filter-block
                      template(v-if="reportId===REPORT_NAME.COLLECTION")
                        div.filter-block
                          Period(
                          :fields="fields"
                          formGroupStyle=""
                          :required="true"
                          )
                          br
                          e-form-group(
                          caption="Физические лица"
                          inputType="checkbox"
                          :model="fields"
                          tabView="tab1"
                          name="fiz"
                          formGroupStyle=""
                          )
                          e-form-group(
                          caption="Юридические лица"
                          inputType="checkbox"
                          :model="fields"
                          tabView="tab1"
                          name="legal"
                          formGroupStyle=""
                          )
                        AddressTree(
                        :fields="fields"
                        )

            div

      div(slot="footer").actions-filter-panel.actions-filter-panel--right
          div
            button(
              type="button"
              :disabled="freezeAllEvents"
              @click="closeModal()"
            ).actions-filter-panel__button.standart.standart-noborder Отмена
            button(
              type="button"
              :disabled="freezeAllEvents"
              @click="submitModal()"
              v-if="userCanCreate"
            ).actions-filter-panel__button.standart Скачать
</template>

<script>
  import reportDownloadBillingMixin from './mixins/report-download-billing-mixin'
  import Legals from "./components/report-field/legals";
  import Period from "./components/report-field/period";
  import AddressTree from "./components/report-field/address-tree";

  export default {
    name: 'report-download',
    components: {AddressTree, Period, Legals},
    mixins: [reportDownloadBillingMixin]
  }
</script>
